import { useState } from "react";
import { Button, Col, Row, Card, Tab, Tabs } from "react-bootstrap";
import { Auth } from "aws-amplify";

import logo from "../Assets/logo-text.png";
import bg from "../Assets/bigbg.jpg";
import { Trans, useTranslation } from "react-i18next";
import SignUpForm from "./Forms/SignUpForm";
import ConfirmSignUpForm from "./Forms/ConfirmSignUpForm";
import SignInForm from "./Forms/SignInForm";
import ChangePasswordForm from "./Forms/ChangePasswordForm";

const AuthState = {
  confirmSignIn: 'confirmSignIn',
  confirmSignUp: 'confirmSignUp',
  signIn: 'signIn',
  signUp: 'signUp'
}

function CustomAuthenticator({ allowSignUp, authStateChanged, setLoading }) {
  const { t } = useTranslation('translation', {keyPrefix: 'form'});
  const [selectedTab, setSelectedTab] = useState(allowSignUp ? AuthState.signUp : AuthState.signIn);
  const [password, setPassword] = useState();
  const [errors, setErrors] = useState();
  const [username, setUsername] = useState();

  const signIn = async function ({ username, password }) {
    try {
      setLoading(true);
      await Auth.signIn(username, password).then((user) => {
        if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          setErrors(null);
          setPassword(password);
          setUsername(username);
          setSelectedTab(AuthState.confirmSignIn);
        } else {
          authStateChanged(user);
        }
      });
    } catch (error) {
      setErrors(error.message);
      console.log("error signing in", error);
    }
  };

  const confirmSignUp = async function({code}) {
    try {
      await Auth.confirmSignUp(username, code).then(success => {
        if (success === "SUCCESS") {
          signIn({username, password});
        }
      });
    }
    catch (error) {
      setErrors(error.message);
      console.log("error confirming signup", error);
    }
  }

  const changePassword = async function ({ confirmPassword }) {
    try {
      await Auth.signIn(username, password).then(async (user) => {
        if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          await Auth.completeNewPassword(user, confirmPassword).then((user) =>
            authStateChanged(user)
          );
        }
      });
    } catch (error) {
      setErrors(error.message);
      console.log("error signing in", error);
    }
  };

  const getForm = () => {
    let el = [];
    if (allowSignUp) {
      el.push(
        <Tabs fill justify defaultActiveKey={AuthState.signUp} id='auth-tabs' className='mb-3'>
          <Tab eventKey={AuthState.signUp} title={t(AuthState.signUp)}>
            {selectedTab === AuthState.signUp ?
              <SignUpForm onSubmit={signUp} apiErrors={errors}/> :
              <ConfirmSignUpForm onSubmit={confirmSignUp} apiErrors={errors} resendConfirmation={resendConfirmation}/>
            };
          </Tab>
          <Tab eventKey={AuthState.signIn} title={t(AuthState.signIn)}>
            <SignInForm onSubmit={signIn} apiErrors={errors}/>
          </Tab>
        </Tabs>
      );
    }
    else {
      if (selectedTab === AuthState.confirmSignIn) {
        el.push(
          <Card.Header>
            <Card.Title>{t('changePassword')}</Card.Title>
          </Card.Header>
        );
        el.push(
          <ChangePasswordForm onSubmit={changePassword} apiErrors={errors}/>
        )
      }
      else {
        el.push(
          <SignInForm onSubmit={signIn} apiErrors={errors}/>
        );
      }
    }
    return el;
  }

  const resendConfirmation = async function() {
    try {
      await Auth.resendSignUp(username);
    }
    catch (err) {
      setErrors(err.message);
      console.log('error resending code: ', err);
    }
  }

  const signUp = async function({username, password, email}) {
    try {
      setLoading(true);
      await Auth.signUp({username, password, attributes: {email}}).then(user => {
        if (!user.userConfirmed) {
          setErrors(null);
          setPassword(password);
          setUsername(username);
          setSelectedTab(AuthState.confirmSignUp);
        }
      });
    }
    catch (error) {
      setErrors(error.message);
      console.log('error signing up: ', error);
    }
  }

  return (
    <Row
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
      }}
    >
      <img
        src={logo}
        style={{
          height: "40px",
          position: "absolute",
          left: "4rem",
          top: "3rem",
          width: "auto",
        }}
        alt="RapidAIM - logo"
      />
      <Col lg={6} className="is-fullheight hero">
        <div className="hero-body">
          <Card className="flex-grow-1 h-auto mx-3">
            {getForm()}
          </Card>
        </div>
      </Col>
      <Col lg={6} className="d-sm-none d-md-block">
        <Row>
          <Col lg={12} className="is-fullheight hero">
            <div className="hero-body">
              <div className="container contents">
                <div className="status">
                  <div>
                    <h1
                      style={{ fontSize: 52, fontWeight: "bold" }}
                      className="text-white"
                    >
                      <Trans i18nKey={'authenticator.header'}/>
                    </h1>
                    <h3 className="text-white mb-5">
                      <Trans i18nKey={'authenticator.subHeader'}/>
                    </h3>
                    <a
                      href="https://rapidaim.io"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Button variant="outline-primary" className="text-white">
                        <Trans i18nKey={'authenticator.button'}/>
                      </Button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default CustomAuthenticator;
